import { render } from "./Timesheet.vue?vue&type=template&id=24bddd88&scoped=true"
import script from "./Timesheet.vue?vue&type=script&lang=js"
export * from "./Timesheet.vue?vue&type=script&lang=js"

import "./timesheet.scss?vue&type=style&index=0&id=24bddd88&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\Peaco-v.1\\PEACO\\peacohrm-main\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24bddd88"]])

export default __exports__